/* 🤖 this file was generated by svg-to-ts*/
export const iconArrowFullDown = {
  name: 'arrow_full_down',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.706 11.414l2.59 2.59c.39.39 1.02.39 1.41 0l2.59-2.59c.63-.63.18-1.71-.71-1.71h-5.18c-.89 0-1.33 1.08-.7 1.71z"/></svg>`,
}
